export enum TicketType {
	ORDER = "current_order",
	CHANGE = "problem_or_change",
	PLACE = "place_order",
	QUOTATION = "quote_request",
	QUESTION = "general_question",
	INCIDENT = "complaint_or_damage",
	INSPIRATION = "report_problem",
	BUSINESS = "business",
	CALLBACK = "call_me_back",
}
